import CardClass from "../../../CardClass";
import EmptyState from "../../../EmptyState";
import MUIButton from "@mui/material/Button";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUISwitch from "@mui/material/Switch";
import MUIIconButton from "@mui/material/IconButton";
import MUIAddIcon from "@mui/icons-material/Add";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUIGrid from "@mui/material/Grid2";
import DialogSearchProductType from "../../../Dialog/Search/DialogSearchProductType";
import TileProductType from "../../../Tile/TileProductType";
import MainContext from "../../../../Context/MainContext/MainContext";

export default class CardAdminQueueFilterOrderActivityPrimaryProductType extends CardClass {
  static contextType = MainContext; // For legacy class components

  constructor(props) {
    super(props);

    this.state.productTypeDialogOpen = false;
  }

  /**
   * Render the content of the card.
   */
  renderContent() {
    const handleRemove = (orderActivityProductsPrimaryProductTypeId) => {
      const filter = this.props.queue.filter;
      if (
        !filter["order_activity_products._primary_product_type_id"]?.properties
          ?.value
      ) {
        return;
      }
      filter[
        "order_activity_products._primary_product_type_id"
      ].properties.value = filter[
        "order_activity_products._primary_product_type_id"
      ].properties.value.filter(
        (entry) => entry !== orderActivityProductsPrimaryProductTypeId,
      );
      if (
        filter["order_activity_products._primary_product_type_id"].properties
          .value.length === 0
      ) {
        delete filter["order_activity_products._primary_product_type_id"];
      }

      this.props.onChange({
        filter: filter,
      });
    };

    const values =
      this.props.queue?.filter?.[
        "order_activity_products._primary_product_type_id"
      ]?.properties?.value || [];

    const excludeChecked =
      this.props.queue?.filter?.[
        "order_activity_products._primary_product_type_id"
      ]?.properties?.operator === "not in";

    const handleExcludeToggle = (event) => {
      const filter = this.props.queue.filter;
      filter[
        "order_activity_products._primary_product_type_id"
      ].properties.operator = event.target.checked ? "not in" : "in";

      this.props.onChange({
        filter: filter,
      });
    };

    if (values.length > 0) {
      return (
        <>
          <MUIFormControlLabel
            sx={{ marginLeft: 0 }}
            control={
              <MUISwitch
                color="error"
                checked={excludeChecked}
                onChange={handleExcludeToggle}
              />
            }
            label="Exclude"
          />
          <MUIGrid container spacing={2}>
            {values.map((orderActivityProductsPrimaryProductTypeId) => {
              return (
                <MUIGrid
                  key={orderActivityProductsPrimaryProductTypeId}
                  size={{
                    xs: 12,
                    sm: 6,
                    md: 4,
                  }}
                >
                  <TileProductType
                    productType={
                      this.context.productTypesIndexed[
                        orderActivityProductsPrimaryProductTypeId
                      ]
                    }
                    iconButtons={[
                      <MUIIconButton
                        onClick={() =>
                          handleRemove(
                            orderActivityProductsPrimaryProductTypeId,
                          )
                        }
                      >
                        <MUIDeleteIcon />
                      </MUIIconButton>,
                    ]}
                  />
                </MUIGrid>
              );
            })}
            {this.renderDialog()}
          </MUIGrid>
        </>
      );
    } else {
      return (
        <>
          <EmptyState
            line1="Not Configured"
            line2="Showing all Primary Product Types"
          />
          {this.renderDialog()}
        </>
      );
    }
  }

  /**
   * Renders a search dialog of Product Types
   */
  renderDialog() {
    const handleAdd = (productType) => {
      const filter = (this.props.queue && this.props.queue.filter) || {};
      if (!filter["order_activity_products._primary_product_type_id"]) {
        filter["order_activity_products._primary_product_type_id"] = {
          type: "set",
          properties: {
            operator: "in",
            value: [],
          },
        };
      }
      filter[
        "order_activity_products._primary_product_type_id"
      ].properties.value = [
        ...new Set([
          ...(filter["order_activity_products._primary_product_type_id"]
            .properties.value || []),
          productType.id,
        ]),
      ];

      this.props.onChange({
        filter: filter,
      });
    };

    return (
      <DialogSearchProductType
        open={this.state.productTypeDialogOpen}
        onClose={() => this.setState({ productTypeDialogOpen: false })}
        onSelect={handleAdd}
      />
    );
  }

  /**
   * Renders add Insurance Type button
   */
  getActions() {
    const handleAdd = () => {
      this.setState({
        productTypeDialogOpen: true,
      });
    };

    const buttonItems = [
      <MUIButton
        component="label"
        variant="outlined"
        startIcon={<MUIAddIcon />}
        onClick={handleAdd}
      >
        Add Product Type
      </MUIButton>,
    ];

    return buttonItems;
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Filter: Order Activity > Primary Product > Type";
  }
}
